app.controller("EvaluationsControlIndexController", ["$scope", "StaticData", "Lecturer", "Session", "$uibModal", "ConfirmModal", "$stateParams", "$state", "toastr", "usSpinnerService",
    function ($scope, StaticData, Lecturer, Session, $uibModal, ConfirmModal, $stateParams, $state, toastr, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.lecturerId = $stateParams.lecturer;
        $scope.range = $stateParams.range;
        $scope.page = $stateParams.page || 1;
        $scope.limit = $stateParams.limit || 25;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        if($stateParams.lecturer) {
            Lecturer.fetchOne($stateParams.lecturer).then(function (data) {
                $scope.lecturer = data;
            });
        }

        StaticData.getItemsByKey("ranges").then(function (ranges) {
            $scope.ranges = [{name: "შუალედი"}].concat(ranges);
            $scope.rangesMap = _.keyBy($scope.ranges, '_id');
        });

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, query, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Session.evaluationsControl({
                lecturer: $scope.lecturerId,
                range: $scope.range,
                page: $scope.page,
                limit:  $scope.limit
            }).then(function (data) {
                $scope.totalItems = data.total;
                $scope.groups = data.docs;
                usSpinnerService.stop("root");
                cb()
            });
        }

        $scope.details = function (groupId) {
            $state.go("admin.lecturerGroup", {groupId: groupId});
        };

        $scope.applyFilter = function () {
            var query = {
                range: $scope.range,
                page: $scope.page,
                limit:  $scope.limit
            };

            if($scope.lecturer &&$scope.lecturer._id ) {
                query.lecturer = $scope.lecturer._id;
            }

            $state.go(".", query);
        };
    }
]);